import { MidiSynth } from "./MidiSynth";
import { OscillatorSynth } from "./OscillatorSynth";
import { ISynth } from "./abstraction/ISynth";


export interface ISynthDeviceInfo {
    deviceId: string;
    name: string;
    create: () => ISynth;
}

class SynthCatalog {

    async enumDevicesAsync() {

        const result: ISynthDeviceInfo[] = [];

        const access = await navigator.requestMIDIAccess({
            software: true,
            sysex: true
        });

        for (const key of access.outputs.keys()) {
            const out = access.outputs.get(key);
            result.push({
                name: "MIDI: " + out.name,
                deviceId: out.name,
                create: () => {
                    const synth = new MidiSynth(out);
                    return synth;
                }
            });
        }

        result.push({
            name: "Oscillator",
            deviceId: "Oscillator",
            create: ()=> new OscillatorSynth()
        });

        return result;
    }

    async getDeviceByIdAsync(id: string) {

        return (await this.enumDevicesAsync()).find(a => a.deviceId == id);
    }
}


export const synthCatalog = new SynthCatalog();